enum RouteNames {
  SIGNUP = "sign_up",
  SIGNIN = "sign_in",
  LOGIN = "login",
  SIGNOUT = "signout",
  LOGOUT = "logout",
  ACCEPT_INVITATION = "acceptInvitation",
  VERIFY_ACCTOUNT = "verifyAccount",
  CONFIRM_ACCOUNT = "confirmAccount",
  FORGOT_PASSWORD = "forgotPassword",
  FORGOT_PASSWORD_CONFIRM = "forgotPassword-confirm",
  RESEND_SIGNUP = "resendSignup",
  CONTRACTOR = "contractor",
  CALENDAR = "Maangement_calendar",
  CONTRACTOR_CALENDAR = "contractor_calendar",
  CONTRACTOR_PROJECTS = "contractor_projects",
  CONTRACTOR_PROJECT_DETAILS = "contractor_project_details-details",
  CONTRACTOR_PROJECT_CALENDAR = "contractor_project_details-calendar",
  CONTRACTOR_PROJECT_CLIENT_PROFILE = "contractor_project_details-client-profile",
  CONTRACTOR_PROJECT_CARE_PLAN = "contractor_project_details-care-plan",
  CONTRACTOR_PROJECT_CLIENT_CARE_LOG = "contractor_project_details-client-care-log",
  CONTRACTOR_PROJECT_ACTIVITY = "contractor_project_activity-activities",
  CONTRACTOR_PROJECT_DOCUMENTS = "contractor_project_documents-documents",
  MARKETPLACE_CONTRACTORS = "marketplace_contractors",
  CONTRACTOR_PUBLIC_PAGE = "contractor_public_page",
  PROFILE_SETTINGS = "profile_settings",
  MANAGE_MANAGERS = "manage_managers",
  CONTRACTOR_FAV = "Favorites",
  MANAGE_PROJECTS = "clients_visit",
  ALL_CLIENTS = "all_clients",
  ALL_VISITS = "all_visits",
  ALL_CLOSED_CLIENTS = "all_closed_clients",
  ALL_ACTIVE_CLIENTS = "all_active_clients",
  ALL_DRAFT_CLIENTS = "all_draft_clients",
  PENDING_VISITS = "pending_visits",
  ALL_DRAFT_VISITS = "draft_visits",
  ACCEPTED_VISITS = "accepted_visits",
  COMPLETED_VISITS = "completed_visits",
  REJECTED_VISITS = "rejected_visits",
  ALL_EMPTY_VISITS = "empty_visits",
  ALL_EMPTY_VISITS_TAB = "empty_visits_tab",
  ALL_COMPLETED_CLIENTS = "closed_client_profiles",
  MANAGE_REQUESTS = "manage_requests",
  MANAGE_DOCUMENTS = "manage_documents",
  MANAGE_TEAMS = "manage_teams",
  MANAGE_GROUP = "manage_group",
  MANAGE_SCHEDULE = "manage_schedule",
  NEW_MANAGE_SCHEDULE = "new_manage_schedule",
  GROUP_DETAILS = "group_details",
  GROUP_DOCUMENTS = "group_documents",
  RECRUITING_POSTINGS = "recruiting_postings",
  RECRUITING_POSTING = "recruiting_posting",
  RECRUITING_POSTING_DETAILS = "recruiting_posting-details",
  RECRUITING_POSTING_APPLICATIONS = "recruiting_posting-applications",
  RECRUITING_POSTING_REVIEW = "recruiting_posting-review",
  RECRUITING_POSTING_APPROVED = "recruiting_posting-approved",
  RECRUITING_POSTING_DECLINED = "recruiting_posting-declined",
  RECRUITING_POSTING_CANCELLED = "recruiting_posting-cancelled",
  JOBBOARD_POSTINGS = "jobboard_postings",
  JOBBOARD_POSTINGS_MARKETPLACE = "jobboard_postings-marketplace",
  JOBBOARD_POSTINGS_INTERNAL = "jobboard_postings-internal",
  JOBBOARD_POSTING = "jobboard_posting",
  JOBBOARD_APPLICATIONS = "jobboard_applications",
  NETWORK_CONNECTIONS = "network_connections",
  NETWORK_COMPANIES = "network_companies",
  NETWORK_COMPANY = "network-company",
  RESOURCES_DOCUMENTS = "resources_documents",
  RESOURCES_PROJECT_DOCUMENTS = "resources_project_documents",
  RESOURCES_TOOLS = "resources_tools",
  PUBLIC_SUPPORT = "public_support",
  INBOX = "inbox",
  INBOX_USER = "inbox_user",
  INBOX_CONVERSATION = "inbox_conversation",
  HOME = "home",
  DASHBOARD = "dashboard",
  USER_PROFILE = "user_profile",
  PROFILE = "profile",
  COMPANY_PROFILE = "company_profile",
  CLIENTS = "clients",
  CLIENT = "client",
  CLIENT_PROJECT = "client_project",
  CLIENT_TEAM = "client_team",
  CLIENT_VISITS = "client_visits",
  CLIENT_All = "client_all",
  ADMIN_CONTRACTORS = "admin_contractors",
  ADMIN_CONTRACTORS_REQUESTS = "admin_contractors-requests",
  CONTRACTOR_ARCHIVED = "Archived",
  CONTRACTOR_PENDING = "Invite not sent",
  CUSTOM_REQUESTS = "custom-requests",
  CONTRACTORS_REQUESTS = "contractors-requests",
  PROJECT_DETAILS = "project_details-details",
  PROJECT_ACTIVITY = "project_details-activities",
  PROJECT_ACTIVITY_EMPTY = "project_details_empty-activities",
  PROJECT_DOCUMENTS = "project_details-documents",
  PROJECT_CLIENT = "project-client",
  PROJECT_CONTRACTORS = "project_details-contractors",
  PROJECT_REQUESTS = "project_details-requests",
  PROJECT_GROUPS = "project_details-groups",
  PROJECT_TIME_TRACKED = "project_details-time-tracked",
  PROJECT_NOTES = "project_details-notes",
  PROJECT_CARE_PLAN = "project-care-plan",
  CUSTOM_REQUEST_DETAILS = "request-details-details",
  REQUEST_UPLOADS = "request-details-uploads",
  REQUEST_CONVERSATIONS = "request-details-conversation",
  REQUEST_TAB_DETAILS = "request-details",
  CUSTOM_REQUESTS_RESOURCES_SUGGESTED = "request-suggested-resources",

  MANAGER_ABOUT = "manager_details-about",
  MANAGER_Edit = "manager_details-about",
  MANAGER_PROJECTS = "manager_details-projects",
  MANAGER_CONTRACTORS = "manager_details-contractors",
  MANAGER_REQUESTS = "manager_details-requests",
  MANAGER_JOB_POSTINGS = "manager_details-job_postings",
  MANAGER_DOCUMENTS = "manager_details-documents",
  CONTRACTOR_DETAILS_ABOUT = "contractor_details-about",
  CONTRACTOR_DETAILS_PROJECTS = "contractor_details-projects",
  CONTRACTOR_DETAILS_VISITS = "contractor_details-visits",
  CONTRACTOR_DETAILS_MANAGERS = "contractor_details-managers",
  CONTRACTOR_DETAILS_DOCUMENTS = "contractor_details-documents",
  CONTRACTOR_DETAILS_REVIEWS = "contractor_details-reviews",
  CONTRACTOR_DETAILS_NOTES = "contractor_details-notes",
  CONTRACTOR_DETAILS_INFO = "contractor_details-additional-info",
  CONTRACTOR_TIMESHEETS = "contractor_timesheets",
  DOCUMENTS_ADMIN_ALL = "documents_admin-all",
  DOCUMENTS_ADMIN_CONTRACTORS = "documents_admin-contractors",
  DOCUMENTS_ADMIN_MANAGERS = "documents_admin-managers",
  DOCUMENTS_ADMIN_PROJECTS = "documents_admin-projects",
  DOCUMENTS_MANAGER_ALL = "documents_manager-all",
  DOCUMENTS_MANAGER_PROJECTS = "documents_manager-projects",
  DOCUMENTS_MANAGER_CONTRACTORS = "documents_manager-contractors",
  MANAGER_CONTRACTOR_DATABASE = "manager_contractor-database",
  MANAGER_CONTRACTOR_REQUESTS = "manager_contractor-requests",
  NOTIFICATIONS = "notifications",
  COMPANY_DATABASE = "company_database",
  COMPANY_DATABASE_CONTRACTORS = "company_database_contractors",
  MY_FAVORITES = "my_favorites",
  ADD_PAYMENT_CARD_AUTH_FORM = "add_payment_card_auth_form",
  CHOOSE_AUTH_SUBSCRIPTIONS = "choose_auth_subscriptions",
  PAYMENT_ROUTES_GUARD = "payment_routes_guard",
  PRICING = "pricing",
  COMPANY_INTERFACE_SETTINGS = "company_interface_settings",
  COMPANY_MARKETPLACE_ACCESS_REQUESTS = "company_marketplace_access_requests",
  TALENT_MAPPING = "talent_mapping",
  COMPANY_RESOURCES = "Company Resources",
  INVOICE = "dashboard-invoice",
  INVOICE_SUBMIT = "dashboard-invoice-submit_invoice",
  INVOICE_DETAIL = "dashboard-invoice-submit-invoice",
  INVOICE_EDIT = "invoice-edit",
  TIMESHEET = "timesheet",
  ONBOARDING = "onboarding",
}

export default RouteNames;
